import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { FrontEndType } from 'components/common/types/Deal.types';
import { Store } from 'components/common/types/Store.types';
import { createNewLineWithUniqueName } from 'store/dealManagement/reducer';
import { CampaignPlannerMode } from 'store/dealManagement/types';
import { getPlannerFamily } from 'utils/isPlannerPath';
import { useProgrammaticHeaderLineContainer } from 'components/pages/Planner/hooks/useProgrammaticHeaderLineContainer';
import { useOnDspInUse } from 'components/pages/DealWithLines/common/Main/ControllerBar/LineActions/DspNoLongerInUse/useOnDspInUse';
import { updateSelectedNonMediaServices } from 'store/nonMediaServices/reducer';
import CampaignHeaderLines from './CampaignHeaderLines';
import { useLineSelect } from './useLineSelect';

const ProgrammaticCampaignHeader: React.FC = () => {
  const dispatch = useDispatch();
  const { onDspInUse } = useOnDspInUse();
  const { selectLine } = useLineSelect();

  const { pathname } = useLocation();
  const isCampaignDrawerOpen = useSelector((state: Store) => state.dealManagement.isCampaignDrawerOpen);
  const campaignPlannerMode = useSelector((state: Store) => state.dealManagement.campaignPlannerMode);
  const isPlannerOverview =
    getPlannerFamily(pathname) === 'programmatic' && campaignPlannerMode === CampaignPlannerMode.OVERVIEW;

  const { headerContainerRef, displayDealLinesDropdown, displayedLines, allLinesSaved, hasReachedMaxLines } =
    useProgrammaticHeaderLineContainer();

  const isAddNewLineDisabled = !allLinesSaved || hasReachedMaxLines;

  const isSelectLineDisabled = !allLinesSaved;

  const onAddNewLineClick = (): void => {
    onDspInUse(() => {
      dispatch(
        createNewLineWithUniqueName(getPlannerFamily(pathname) === 'programmatic' ? undefined : FrontEndType.STANDARD),
      );
      dispatch(updateSelectedNonMediaServices({ selectedNonMediaServices: [] }));
    });
  };

  return (
    <CampaignHeaderLines
      isDealLinesDropdownVisible={displayDealLinesDropdown}
      displayedLines={displayedLines}
      headerContainerRef={headerContainerRef}
      isAddNewLineDisabled={isAddNewLineDisabled}
      isCampaignDrawerOpen={isCampaignDrawerOpen}
      isOverviewMode={isPlannerOverview}
      isSelectLineDisabled={isSelectLineDisabled}
      onAddNewLineClick={onAddNewLineClick}
      onLineSelect={selectLine}
    />
  );
};

export default ProgrammaticCampaignHeader;
